<template>
  <div>
    <a-form :form="form" layout="vertical" class="report">
    <a-form-item class="inline" label="报告标题：">
      <a-input
        size="large"
        :style="{ width: '750px' }"
        placeholder="请填写报告标题"
        v-decorator="[
          'title',
          { rules: [{ required: true, message: '请填写报告标题' }] }
        ]"
      />
    </a-form-item>
    <a-form-item label="求职动机：">
      <a-radio-group
        class="block-radio theme-radio"
        v-decorator="[
          'motivation',
          { rules: [{ required: true, message: '请选择求职动机' }] }
        ]"
      >
        <template v-for="(item, index) in motivation">
          <a-radio :key="index" :value="index">
            <span>{{ item.text }}</span>
            <input type="text" class="add-input" v-if="item.editable" v-model="item.extra" />
          </a-radio>
        </template>
      </a-radio-group>
    </a-form-item>
    <a-form-item label="推荐理由：">
      <a-checkbox-group
        class="block-radio theme-radio"
        v-decorator="[
          'post_reason',
          { rules: [{ required: true, message: '请选择推荐理由' }] }
        ]"
      >
        <template v-for="(item, index) in reason">
          <a-checkbox :key="index" :value="index">
            <span>{{ item.text }}</span>
            <input type="text" class="add-input" v-if="item.editable" v-model="item.extra" />
          </a-checkbox>
        </template>
      </a-checkbox-group>
    </a-form-item>

    <a-form-item label="入职时间：">
      <a-radio-group
        class="theme-radio"
        v-decorator="[
          'expect_on_board_time',
          { rules: [{ required: true, message: '请选择入职时间：' }] }
        ]"
      >
        <template v-for="(item, key) in config.arrival_time">
          <a-radio :key="key" :value="key">{{ item }}</a-radio>
        </template>
      </a-radio-group>
    </a-form-item>
    <a-form-item label="猎头顾问评价：">
      <a-row type="flex" align="top">
        <a-col span="21" class="area">
          <a-textarea
            style="padding-bottom: 50px;"
            placeholder="请填写评价"
            :rows="6"
            @change="handleAssessLength"
            v-decorator="[
              'adviser_remark',
              {
                rules: [
                  { required: true, message: '请填写评价' },
                  { max: 1000, message: '请控制文本不超过500字符' }
                ]
              }
            ]"
          ></a-textarea>
          <span class="count" style="position: absolute; left: 20px; bottom: 15px;">{{ assessLength }} / 1000</span>
          <div class = "ai-button"  @click="showAIDialog()">AI一键生成猎头顾问评价</div>
        </a-col>
      </a-row>
    </a-form-item>
    <div class="title">薪资：</div>
    <div class="group">
      <a-form-item class="inline" label="期望薪资：">
        <a-input
          size="large"
          :style="{ width: '180px' }"
          v-decorator="[
            'expect_salary_basis',
            {
              rules: [
                { required: true, message: '请填写期望薪资' },
                {
                  transform(value) {
                    return +value;
                  },
                  type: 'number',
                  message: '请输入数字！'
                }
              ]
            }
          ]"
        >
          <span slot="suffix">元</span>
        </a-input>
        <a-icon type="close" :style="{ fontSize: '18px', margin: '0 15px 0 20px' }"></a-icon>
      </a-form-item>
      <a-form-item class="inline">
        <span slot="label"></span>
        <a-input
          size="large"
          :style="{ width: '180px' }"
          v-decorator="[
            'expect_salary_months',
            {
              rules: [
                { required: true, message: '请填写' },
                {
                  transform(value) {
                    return +value;
                  },
                  type: 'number',
                  message: '请输入数字！'
                }
              ]
            }
          ]"
        >
          <span slot="suffix">月</span>
        </a-input>
        <a-icon
          type="pause"
          :style="{
            fontSize: '18px',
            margin: '0 20px',
            transform: 'rotate(90deg)'
          }"
        ></a-icon>
      </a-form-item>
      <a-form-item class="inline">
        <span slot="label"></span>
        <a-input size="large" disabled :style="{ width: '180px' }" v-decorator="['expect_all']">
          <span slot="suffix">元</span>
        </a-input>
      </a-form-item>
      <a-form-item label :style="{ marginLeft: '30px' }">
        <a-radio-group
          v-decorator="[
            'expect_salary_type',
            { rules: [{ required: true, message: '请选择薪资类型：' }] }
          ]"
        >
          <a-radio value="BEFORE">税前</a-radio>
          <a-radio value="AFTER">税后</a-radio>
        </a-radio-group>
      </a-form-item>
    </div>
    <div class="group">
      <a-form-item class="inline" label="目前薪资：">
        <a-input
          size="large"
          :style="{ width: '180px' }"
          v-decorator="[
            'current_salary_basis',
            {
              rules: [
                { required: true, message: '请填写薪资' },
                {
                  transform(value) {
                    return +value;
                  },
                  type: 'number',
                  message: '请输入数字！'
                }
              ]
            }
          ]"
        >
          <span slot="suffix">元</span>
        </a-input>
        <a-icon type="close" :style="{ fontSize: '18px', margin: '0 15px 0 20px' }"></a-icon>
      </a-form-item>
      <a-form-item class="inline">
        <span slot="label"></span>
        <a-input
          size="large"
          :style="{ width: '180px' }"
          v-decorator="[
            'current_salary_months',
            {
              rules: [
                { required: true, message: '请填写' },
                {
                  transform(value) {
                    return +value;
                  },
                  type: 'number',
                  message: '请输入数字！'
                }
              ]
            }
          ]"
        >
          <span slot="suffix">月</span>
        </a-input>
        <a-icon
          type="pause"
          :style="{
            fontSize: '18px',
            margin: '0 20px',
            transform: 'rotate(90deg)'
          }"
        ></a-icon>
      </a-form-item>
      <a-form-item class="inline">
        <span slot="label"></span>
        <a-input size="large" disabled :style="{ width: '180px' }" v-decorator="['all']">
          <span slot="suffix">元</span>
        </a-input>
      </a-form-item>
      <a-form-item label :style="{ marginLeft: '30px' }">
        <a-radio-group
          v-decorator="[
            'current_salary_type',
            { rules: [{ required: true, message: '请选择薪资类型：' }] }
          ]"
        >
          <a-radio value="BEFORE">税前</a-radio>
          <a-radio value="AFTER">税后</a-radio>
        </a-radio-group>
      </a-form-item>
    </div>
    <div class="group">
      <a-form-item label="补充说明：" class="inline memo area">
        <a-textarea
          placeholder="客户指定要这一类背景的候选人，候选人对客户动机不明确，但是可引导"
          :rows="6"
          @change="handleMemoLength"
          v-decorator="[
            'current_income_extra',
            { rules: [{ max: 200, message: '请控制文本不超过200字符' }] }
          ]"
        ></a-textarea>
        <span class="count">{{ memoLength }} / 200</span>
      </a-form-item>
    </div>
    <a-form-item v-if="resume.source!='columbus_mini_app'">
      <span slot="label">
        简历附件：
        <span>（请选择一份合适的简历提交）</span>
      </span>
      <a-radio-group
        class="block-radio"
        v-decorator="[
          'resume_attachment_id',
          { rules: [{ required: true, message: '请选择简历附件' }] }
        ]"
      >
        <template v-for="item in attche">
          <a-radio :value="item.id" :key="item.id">
            <a
              @click.prevent.stop="previewResume(item)"
              style="margin-right:20px;text-decoration:underline"
            >{{ item.file_name }}</a>
            {{ item.created_at }}
          </a-radio>
        </template>
      </a-radio-group>

      
    </a-form-item>

    <a-drawer :visible="preview" :width="850" @close="preview = !preview">
      <img :src="preview_url" alt />

    </a-drawer>
    <VueDragResize
        v-if = "showAIAlert"
        :isActive="true"
        :isResizable="false"
        :preventActiveBehavior="true"
        :delay="1"
        class="custom-draggable-resizable"
        style = "
        position: fixed;
        z-index: 99999;
        background: #FFFFFF;
        box-shadow: 0px 3px 6px 0px rgba(0,0,0,0.2);
        border-radius: 6px;"
        :w="500"
        :h="480"
        :x="this.windowWidth - 520"
        :y="200">
        <AIAssistant @close="closeAct()" :jsonData = "alertData" :contentType = "aiContentType" @filling = "filling"/>
    </VueDragResize>
  </a-form>

  </div>
  
   
</template>

<script>

import VueDragResize from 'vue-drag-resize';
import AIAssistant from '@/components/ai-assistant/ai-assistant.vue'
import { mapState } from "vuex";
import moment from "moment";
import Api from "@/api";
export default {
  name: "report",
  props: {
    resume: {
      type: Object,
      default: () => {
        return {};
      }
    },
    jobName: {}
  },
  components:{
    AIAssistant,
    VueDragResize
  },
  data() {
    return {
      showAIAlert: false,
      aiContentType: "3",
      alertData : null,
      windowWidth : 0,
      preview: false,
      preview_url: "",
      assessLength: 0,
      memoLength: 0,
      motivation: [
        {
          text:
            "谋求个人发展，追求晋升空间：期望转换进入更理想行业，晋升为管理者岗位；进入行业内领先企业，创业初期的企业或井喷式企业；期望寻找工作职权更大， 管理幅度更大的职位",
          editable: false,
          extra: ""
        },
        {
          text: "追求薪酬涨幅，包括福利、底薪、奖金、期权、股权",
          editable: false,
          extra: ""
        },
        { text: "因家庭或其他原因，改变工作地点", editable: false, extra: "" },
        {
          text:
            "目前企业倒闭/裁员/业务紧缩，寻求工作前景明朗的企业发展，获得更好的发展机会",
          editable: false,
          extra: ""
        },
        {
          text: "和上级关系相处不融洽，寻求新的工作环境",
          editable: false,
          extra: ""
        },
        {
          text:
            "不适应目前工作环境/文化/节奏，希望找一份更安逸/稳定/工作压力小的工作",
          editable: false,
          extra: ""
        },
        { text: "离职原因", editable: true, extra: "" },
        { text: "看机会原因", editable: true, extra: "" },
        { text: "其他", editable: true, extra: "" }
      ],
      reason: [
        {
          text:
            "候选人有本岗位直接相关工作经验，或虽然无直接相关的工作经验，但是拥有本岗位所需的胜任力",
          editable: false,
          extra: ""
        },
        {
          text: "候选人软性素质与客户要求匹配度高",
          editable: false,
          extra: ""
        },
        {
          text: "候选人软性素质与客户要求部分匹配",
          editable: false,
          extra: ""
        },
        { text: "候选人对企业有很强的兴趣度", editable: false, extra: "" },
        {
          text:
            "客户指定要这一类背景的候选人，候选人对客户动机不明确，但是可引导",
          editable: false,
          extra: ""
        },
        { text: "其他", editable: true, extra: "" }
      ],
      input: false,
      input0: false,
      attche: []
    };
  },
  computed: {
    ...mapState(["job", "config"])
  },
  created() {
    Api.position.getAttachedResume({ resume_id: this.resume.id }).then(res => {
      this.attche = res.attachments;
    });
    this.form = this.$form.createForm(this, {
      onFieldsChange: (props, fileds) => {
        if (fileds.current_salary_basis || fileds.current_salary_months) {
          this.calcSalary();
          return;
        }
        if (fileds.expect_salary_basis || fileds.expect_salary_months) {
          this.calcExpectSalary();
          return;
        }
      }
    });

    this.getWindowWidth(); // 在组件挂载后获取窗口宽度
    window.addEventListener("resize", this.getWindowWidth); // 添加窗口大小变化的事件监听
  },
  mounted() {
    console.log("XXX:");
    console.log(this.resume.id);
    console.log(this.resume);
    const jsonMap = new Map();
    jsonMap.set('resumeId', this.resume.id);

    this.alertData = jsonMap;

    let title = `${this.resume.resume.name}-${moment().format("YYYY/MM/DD")}-${
      this.jobName
    }`;
    this.form.setFieldsValue({
      title: title
    });


  },
  beforeDestroy() {
    window.removeEventListener("resize", this.getWindowWidth); // 组件销毁前移除事件监听
  },
  methods: {
    closeAct(){
      this.showAIAlert = false;
    },
    filling(val){
      this.showAIAlert = false;
      this.form.setFieldsValue({
        adviser_remark: val
      });
      this.assessLength = val.length;
    },
    getWindowWidth() {
      this.windowWidth = window.innerWidth; // 获取窗口宽度
      console.log(" window.innerWidth:");
      console.log(window.innerWidth);
    },
    showAIDialog(){
      //显示AI弹窗
      console.log("test");
      this.showAIAlert = true;

    },
    handleAssessLength(e) {
      this.assessLength = e.target.value.length;
    },
    handleMemoLength(e) {
      this.memoLength = e.target.value.length;
    },
    submit() {
      return new Promise((resolve, reject) => {
        this.form.validateFieldsAndScroll((err, values) => {
          if (!err) {
            let formData = JSON.parse(JSON.stringify(values));
            let item = this.motivation[formData.motivation];
            if (item.editable && item.extra.length > 0) {
              formData.motivation = `${item.text}：${item.extra}`;
            } else {
              formData.motivation = item.text;
            }
            formData.post_reason = formData.post_reason
              .sort((a, b) => a - b)
              .map(i => {
                let item = this.reason[i];
                if (item.editable && item.extra.length > 0) {
                  return `${item.text}：${item.extra}`;
                } else {
                  return item.text;
                }
              });
            console.log("submit", formData);
            resolve({ ...formData });
          } else {
            reject();
          }
        });
      });
    },
    calcExpectSalary() {
      let {
        expect_salary_basis: salary,
        expect_salary_months: month
      } = this.form.getFieldsValue([
        "expect_salary_basis",
        "expect_salary_months"
      ]);
      this.$nextTick().then(() => {
        if (salary > 0 && month > 0) {
          this.form.setFieldsValue({
            expect_all: salary * month
          });
        } else {
          this.form.setFieldsValue({
            expect_all: ""
          });
        }
      });
    },
    calcSalary() {
      let {
        current_salary_basis: salary,
        current_salary_months: month
      } = this.form.getFieldsValue([
        "current_salary_basis",
        "current_salary_months"
      ]);
      this.$nextTick().then(() => {
        if (salary > 0 && month > 0) {
          this.form.setFieldsValue({
            all: salary * month
          });
        } else {
          this.form.setFieldsValue({
            all: ""
          });
        }
      });
    },
    // 简历预览
    async previewResume(attachment) {
      let preview_url = attachment.preview_url;
      if (preview_url) {
        this.preview = true;
        this.preview_url = preview_url;
      } else {
        let { preview } = await Api.resume.generatePreview({
          attachment_id: attachment.id
        });
        this.preview = true;
        this.preview_url = preview.file_url;
      }
    }
  }
};
</script>

<style lang="scss">
.report.ant-form {
  padding: 20px 25px 50px;
  .add-input {
    border: none;
    border-bottom: 1px solid rgba(220, 223, 230, 1);
    width: 300px;
    outline: none;
    margin-left: 10px;
    font-size: 14px;
  }
  .title {
    font-size: 16px;
    color: #000;
    font-weight: bold;
    padding-bottom: 20px;
  }
  .ant-form-item-label {
    padding: 0 0 20px 0;
    label {
      font-size: 16px;
      color: #000;
      font-weight: bold;
      & span > span {
        color: #909399;
        font-size: 14px;
        font-weight: normal;
      }
    }
  }
  .inline {
    &.memo {
      .ant-form-item-control-wrapper {
        width: 800px;
      }
    }
    .ant-form-item-label {
      padding: 6px 0px 0 0;
    }
    display: flex;
    align-items: flex-start;
    justify-items: flex-start;
  }
  .block-radio {
    .ant-radio-wrapper {
      display: flex;
      align-items: center;
      margin-bottom: 10px;
      span.ant-radio {
        margin-right: 10px;
        & + * {
          white-space: normal;
        }
      }
    }
    .ant-checkbox-wrapper {
      margin-left: 8px;
      display: flex;
      align-items: center;
      margin-bottom: 10px;
      span.ant-checkbox {
        margin-right: 10px;
        & + * {
          white-space: normal;
        }
      }
    }
  }
  .theme-radio {
    .ant-radio-wrapper {
      &.ant-radio-wrapper-checked {
        span.ant-radio + span {
          color: #35b5fe;
        }
      }
    }
    .ant-checkbox-wrapper {
      .ant-checkbox-checked + span {
        color: #35b5fe;
      }
    }
  }
  .area {
    .ant-input {
      resize: none;
      padding: 10px;
    }
    position: relative;
    .count {
      color: #999;
      position: absolute;
      right: 15px;
      bottom: 13px;
    }
  }
  .group {
    display: flex;
    padding-left: 20px;
    align-items: center;
    .inline {
      .ant-form-item-label label {
        font-weight: normal;
      }
    }
  }
  .ai-button {
    width: 147px;
    height:32px;
    background-color: #7788FF;
    border-radius: 4px;
    position: absolute;
    right: 20px;
    bottom: 10px;
    justify-content: center;
    align-items: center;
    display: flex;
    color: #FFFFFF;
    font-size:12px;
    font-weight: 400;
    font-family: PingFangSC-Regular, PingFang SC;
  }
  // 取消默认外边框虚线
  .vdr.active:before {
    display: none;
  }
}
</style>
